<template>
  <div class="mk-message">
    <div class="mk-message__container">
      <button
        class="mk-message__container__close"
        @click="closeCallback"
      >
        X
      </button>
      <span class="mk-message__title">{{title}}</span>
      <div class="mk-message__message">
        {{message}}
      </div>
    </div>
  </div>
</template>

<script>
/**
 * MessagePopup
 * @author David <david.prenninger@gmx.de>
 *
 * This component is a generic Message popup.
 */
export default {
  props: {
    message: String,
    title: String,
    closeCallback: Function,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/defaults.scss";

.mk-message {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba($c_primary, 0.1);
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;

  &__container {
    position: relative;
    display: flex;
    height: 100px;
    flex-direction: column;
    padding: 10px;
    border-radius: $br_md;
    box-shadow: $bs_md;
    background-color: $c_white;

    &__close {
      background-color: $c_white;
      box-shadow: $bs_md;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      position: absolute;
      top: 10px;
      right: 10px;
      border: none;
    }
  }

  &__title {
    font-size: 20px;
    margin: 10px;
    text-transform: capitalize;
  }
}
</style>
